// src/components/Footer.jsx
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { SiX, SiInstagram, SiTiktok, SiYoutube } from 'react-icons/si'
import useLocalePath from '../i18n/useLocalePath'

export default function Footer() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { lp } = useLocalePath()
  const year = new Date().getFullYear()

  const isHome = pathname === '/' || pathname === '/es'

  return (
    <footer
      className={`
        w-full font-rubik 
        bg-[#13C5C5] text-white 
        ${isHome ? '' : 'border-t border-gray-200'}
      `}
    >
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
        {/* Support links */}
        <div className="flex flex-col items-center md:items-start space-y-1">
          <h3 className="text-lg font-semibold text-white">
            {t('footer.support')}
          </h3>
          <Link
            to={lp('/terms-of-service')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.terms_of_service')}
          </Link>
          <Link
            to={lp('/privacy-policy')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.privacy_policy')}
          </Link>
          <Link
            to={lp('/faq')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.faq')}
          </Link>
          <Link
            to={lp('/blog')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.blog')}
          </Link>
          <Link
            to={lp('/free-guide')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.free_guide')}
          </Link>
          <Link
            to={lp('/about')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.about')}
          </Link>
          <Link
            to={lp('/delete-account')}
            className="text-sm text-white font-medium hover:underline"
          >
            {t('footer.delete_account')}
          </Link>
        </div>

        {/* Social icons */}
        <div className="flex items-center space-x-4">
          {[
            { Icon: SiX,         url: 'https://x.com/NekochanApp',          label: 'X' },
            { Icon: SiInstagram, url: 'https://www.instagram.com/nekochanapp/', label: 'Instagram' },
            { Icon: SiTiktok,    url: 'https://www.tiktok.com/@nekochanapp',   label: 'TikTok' },
            { Icon: SiYoutube,   url: 'https://www.youtube.com/@NekochanApp',   label: 'YouTube' },
          ].map(({ Icon, url, label }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="text-white opacity-80 hover:opacity-100 transition-opacity"
            >
              <Icon size={24} />
            </a>
          ))}
        </div>
      </div>

      {/* copyright bar */}
      <div className="text-center py-4 text-xs leading-[17px]">
        {t('footer.copyright', { year, company: 'Nekochan SA.' })}
      </div>
    </footer>
  )
}
